import { routeName } from '@/constants/routeName';
import List from '@/views/BaromoneyAccruedExpensesList/List/index.vue';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'baromoney-accrued-expenses-list',
        name: routeName.BAROMONEY_ACCRUED_EXPENSES_LIST,
        component: List,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
];
